<!-- Permission Dialog -->
<div class="flex flex-column w-full h-full">
  <!-- Content -->
  <div class="flex flex-1 flex-column overflow-hidden justify-content-start">
    @if (filteredUserArray && filteredUserArray.length > 0) {
      <!-- Form -->
      @if (shareForm) {
        <medsurf-design-form-control-form
          [formGroup]="shareForm"
          (onSubmit)="onSubmit()">
          <!-- User -->
          <medsurf-design-form-control-input-dropdown [control]="shareForm.controls.id"
            [autofocus]="true"
            [options]="filteredUserArray"
            [filter]="true"
          [label]="'global.user_shares'"></medsurf-design-form-control-input-dropdown>
          <!-- Submit -->
          <medsurf-design-form-control-input-submit [label]="'global.user_shares_add'"
          [disabled]="shareForm.invalid || isSubmitted()"></medsurf-design-form-control-input-submit>
        </medsurf-design-form-control-form>
      }
    }
    <div class="max-h-modal-user-shares">
      <!-- Update Shares -->
      @if (node.shares && node.shares.length > 0) {
        <p-table
          [value]="getUsers(node.shares, typedUsers)"
          class="flex flex-1 overflow-hidden align-self-center w-full h-full mb-2"
          styleClass="w-full"
          [rowTrackBy]="rowTrackBy"
          [scrollable]="true"
          scrollHeight="100%"
          sortField="lastName">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="lastName">
                <span translate="global.last_name"></span> <p-sortIcon field="lastName"></p-sortIcon>
              </th>
              <th pSortableColumn="firstName">
                <span translate="global.first_name"></span> <p-sortIcon field="firstName"></p-sortIcon>
              </th>
              <th pSortableColumn="role">
                <span translate="global.role"></span> <p-sortIcon field="role"></p-sortIcon>
              </th>
              <th>
                <span translate="global.user_shares_remove"></span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr [pSelectableRow]="user.id">
              <td>
                {{ user.lastName }}
              </td>
              <td>
                {{ user.firstName }}
              </td>
              <td>
                <span class="label label-default">{{ user.role }}</span>
              </td>
              <td>
                <div class="flex justify-content-center">
                  <button medsurf-design-input-button [id]="'user_shares_remove'"
                    [title]="'global.user_shares_remove' | translate"
                    [inputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.DANGER"
                    [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.REMOVE"
                  (click)="deleteShare(user.id)"></button>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      }
    </div>
  </div>
</div>
